export default function KeyIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15 3a6 6 0 0 0-6 6c0 .64.1 1.25.28 1.82L3 17.09V21h3v-1.5h1.5V18h1.5v-1.5h1.73A6 6 0 0 0 21 9a6 6 0 0 0-6-6Zm0 3a3 3 0 1 1-3 3 3 3 0 0 1 3-3Z"
        fill="currentColor"
      />
    </svg>
  )
}
